import React, {Component} from "react";
import Authentication from "../../authentication/Authentication";
import moment from "moment";
import "./EditJobContainer.css"

export default class EditJobContainer extends Component {

    constructor(props) {
        super(props);
        this.state = {
            showCustomDateCalander: false,
            scheduledDate: this.props.job.scheduledDate,
            isValidDate: true,
            isModifying: false,
            showConfirm: false,
            input: ""
        };

        this.authentication = new Authentication();
    };


    toggleCustomDateCalander = () => {
        this.setState({
            showCustomDateCalander: !this.state.showCustomDateCalander
        })
    }

    handleScheduledDateChange(event) {
        if (event.target.value > new Date().toISOString().slice(0, 10)) {
            this.setState({
                scheduledDate: event.target.value,
                isValidDate: true,
            })
        } else {
            this.setState({
                isValidDate: false,
                showConfirm: false
            })
        }
    }

    formatDate = (date) => {
        const momentDate = moment(date)
        if (momentDate.isValid()) {
            return momentDate.format("MMMM Do YYYY HH:mm:ss");
        }
        return "";
    };

    getLocaleDateDifference = (scheduledDate, newDate) => {
        const currentScheduledDate = new Date(scheduledDate);
        const modifiedDate = new Date(newDate);
        const difference =  (modifiedDate.getTime() - currentScheduledDate.getTime()) / 1000;
        return difference
    }

    handleInputChange(event) {
        if (event.target.value === "confirm") {
            this.setState({
                input: event.target.value,
                showConfirm: true
            })
        } else {
            this.setState({
                input: event.target.value,
                showConfirm: false
            })
        }

    }

    handleConfirm(event, event_tag){
        if (this.state.input === 'confirm' && this.state.isValidDate){
            this.setState({
                isModifying: true
            })
            const endDate = this.state.scheduledDate + " " + new Date().toLocaleTimeString();
            const timeDifference = this.getLocaleDateDifference(this.props.currentScheduledDate, endDate)
            this.props.handleCustomiseScheduledDate(this.props.job.job_queue_id, timeDifference)
        }
    }


    renderDatePopup = () => {
        return (
            <div className="scheduled-job-edit-date" data-testid="job.date.editor">
                <span className="try-pi-verification-title" data-testid="job.date.editor.title">Customise scheduled date: </span>
                <div className="try-pi-custom-end-date-element" data-testid="job.date.editor.endDate">
                    <input className="try-pi-custom-end-date-input" data-testid="job.date.editor.endDate.input" type="date" onChange={(event)=> this.handleScheduledDateChange(event)}/>
                    {this.state.isValidDate ? ''  : <span className="try-pi-custom-end-date-invalid-date-message" data-testid="job.date.editor.error">Please enter a future date</span> }
                </div>
                {this.state.isModifying ? <i className="fa fa-spinner fa-pulse fa-3x fa-fw loading"/> :
                    <div className="try-pi-verification-form-element" data-testid="job.date.editor.confirm">
                        <span className="try-pi-verification-instructions" data-testid="job.date.editor.confirm.input">Type 'confirm' to change date :<input placeholder={"confirm"} value={this.state.input} onInput={(event) => this.handleInputChange(event, "some stuff")} className="try-pi-verification-input"/></span>
                    </div>
                }
                {this.state.showConfirm ? <button className={"btn-confirm"} data-testid="job.date.editor.button.confirm" onClick={() => this.handleConfirm()}>Confirm</button> : <></>}
                <button className={"btn-cancel"} data-testid="job.date.editor.button.cancel" onClick={() => this.toggleCustomDateCalander()}>Cancel</button>
            </div>
        )
    }

    render() {
        return (
            <div className={"pisaas-popup-container"} data-testid="job.editor.popUp.container">
                <div className={"box"}>
                    <button className="try-pi-btn close-button" data-testid="job.editor.button.close" onClick={() => this.props.toggleEditPopup()}>X</button>
                    <h2 data-testid="job.editor.heading.editPanel">Edit Panel</h2>
                    <div className={"gap-top-4 job-info"}>
                        <h3 className={"editable-job-title field-name"}  data-testid="job.editor.heading.jobDetails">Job Details:</h3>
                        <span className={"edit-info-text"} data-testid="job.editor.serviceName">Service Name: {this.props.job.service_name}</span><br/>
                        <span className={"edit-info-text"} data-testid="job.editor.job">Job: {this.props.job.description}</span><br/>
                        <span className={"edit-info-text"} data-testid="job.editor.status">Current Status: {this.props.job.status}</span><br/>
                    </div>
                    <div className={"field-column gap-top-4"}>
                        <span className="editable-job-title field-name" data-testid="job.editor.updateScheduledDate">Update Scheduled Date: </span>
                        <span className={"edit-info-text"} data-testid="job.editor.scheduledDate">{this.formatDate(this.props.job.scheduled_date)}</span>
                        <div className={"job-action"} data-testid="job.editor.button.edit" onClick={() => this.toggleCustomDateCalander()}>
                            <i className="fa fa-calendar job-icon"></i>
                            <p className={"edit-text"}>EDIT</p>
                        </div>
                        {this.state.showCustomDateCalander ? this.renderDatePopup() : <></>}
                    </div>
                </div>
            </div>
        )
    }
}



